/**
 * DocAndFormTemplates - Combined Document & Form Templates page
 *
 * Wraps DocumentTemplatesList and FormTemplatesList in a tabbed layout
 * so both are accessible from a single nav item.
 */
import { useState } from 'react';
import { Button } from '@respectly/ui';
import { FileText, ClipboardList } from 'lucide-react';
import { DocumentTemplatesList } from './DocumentTemplatesList';
import { FormTemplatesList } from './FormTemplatesList';

type Tab = 'document' | 'form';

export function DocAndFormTemplates() {
  const [activeTab, setActiveTab] = useState<Tab>('document');

  return (
    <div>
      <div className="px-4 lg:px-6 pt-4 pb-2 flex gap-2">
        <Button
          variant={activeTab === 'document' ? 'default' : 'outline'}
          size="sm"
          onClick={() => setActiveTab('document')}
          className="gap-2"
        >
          <FileText className="h-4 w-4" />
          Document Templates
        </Button>
        <Button
          variant={activeTab === 'form' ? 'default' : 'outline'}
          size="sm"
          onClick={() => setActiveTab('form')}
          className="gap-2"
        >
          <ClipboardList className="h-4 w-4" />
          Form Templates
        </Button>
      </div>

      {activeTab === 'document' ? <DocumentTemplatesList /> : <FormTemplatesList />}
    </div>
  );
}
